import { render, staticRenderFns } from "./BaseTPQuestionForm.vue?vue&type=template&id=05cadf93&scoped=true&"
import script from "./BaseTPQuestionForm.vue?vue&type=script&lang=js&"
export * from "./BaseTPQuestionForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseTPQuestionForm.vue?vue&type=style&index=0&id=05cadf93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cadf93",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VChip,VCol,VContainer,VForm,VRow})
